import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useGetCollectionComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { CollectionComponentTypeFormBuilder } from './CollectionComponentTypeFormBuilder';

interface CollectionComponentTypeEditFormProps {
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const CollectionComponentTypeEditForm = ({
  onSubmit,
  onCancel,
}: CollectionComponentTypeEditFormProps) => {
  const collectionComponentTypeByIdMultilingual =
    useGetCollectionComponentTypeByIdMultilingual();

  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Edit Type'}`}
          origintext="Edit Type"
        />
      </h1>
      <div className="mt-6">
        {collectionComponentTypeByIdMultilingual.data && (
          <CollectionComponentTypeFormBuilder
            type="Edit"
            onSubmit={onSubmit}
            onCancel={onCancel}
            data={collectionComponentTypeByIdMultilingual.data}
          />
        )}
      </div>
    </div>
  );
};
